import { useContext } from "react";
import { StateListContext } from "../context";

export const useStates = () => useContext(StateListContext);
